module.exports = __webpack_public_path__ + "static/media/money.80f99647.jpg";